import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-member-verification-label-item',
  templateUrl: './member-verification-label-item.component.html',
  styleUrls: ['./member-verification-label-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MemberVerificationLabelItemComponent {
  @Input() label: string | undefined;
  @Input() text: string | number | undefined;
  @Input() highlightRow: boolean = true;
  @Input() hideBottomBorder: boolean = false;
  @Input() isLoading: boolean = false;
}
